"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { RulesSection } from "@features/rules-section/ui/rules-section";

import { Container } from "@shared/ui/container";
import { UniversalGallery } from "@shared/ui/universal-gallery";

import { Page } from "@/widgets/Page";

import type { TrailsListType, TrailsPageType } from "../../model";
import { CableWayCard } from "../cable-way-card";
import { TrailsTable } from "../trails-table";

import s from "./trails-page.module.scss";

export type TrailsPageProps = ComponentProps<"div"> & {
  className?: string;
  pageData: TrailsPageType;
  trails: TrailsListType;
};

export const TrailsPage = (props: TrailsPageProps) => {
  const { className, pageData, trails } = props;

  // Разделяем трассы и канатные дороги
  const cableWays = trails.filter((trail) => trail.trailType === "cable-way");
  const trailList = trails.filter((trail) => trail.trailType === "trail");

  return (
    <Page
      // @ts-expect-error - Type inference issue: zod inferred type vs explicit type are structurally identical but TypeScript sees them as different
      title={pageData.titleWithIcon}
      className={clsx(s.root, className)}
    >
      <Container className={s.content}>
        {/* Список карточек канатных дорог */}
        {cableWays.length > 0 && (
          <div className={s.cableWaysList}>
            {cableWays.map((cableWay) => (
              <CableWayCard
                key={cableWay.id}
                trail={cableWay}
                className={s.cableWayCard}
              />
            ))}
          </div>
        )}

        {/* Список трасс (строковый вид) */}
        {trailList.length > 0 && (
          <TrailsTable trails={trailList} className={s.trailsTable} />
        )}

        {/* Галерея трасс */}
        {pageData.gallerySection && (
          <UniversalGallery
            subtitle={pageData.gallerySection.subtitle}
            title={pageData.gallerySection.title}
            gallery={pageData.gallerySection.gallery}
            className={s.gallery}
          />
        )}
      </Container>

      {/* Правила */}
      {pageData.rulesSection && (
        <RulesSection data={pageData.rulesSection} className={s.rulesSection} />
      )}
    </Page>
  );
};

TrailsPage.displayName = "TrailsPage";
